import {
    Button, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle
} from '@mui/material';
import api from '../../service/api';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useHistory } from "react-router-dom";
import CancelIcon from '@mui/icons-material/Cancel'
import ProgressBar from '../progress/progressBar';
import popUpMessage from '../../config/popUpMsg.json';
import LillySource from '../../config/ProfileDetailsData.json'



const PopupConfimation = (props) => {
    const history = useHistory();
    const [value, setValue] = useState('');
    const [submit, setSubmit] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [popUptext, setPopUptext]= useState({comment : '' , success : false})
    const [open, setOpen] = useState(false);
    const [popMsg] = useState(popUpMessage.newHCO)
    const [disableSubmit, setDisableSubmit] = useState(false);
    let originalValues;

    if (props?.originalValues?.Address != null){
       const convertedAddress = Object.values(props.originalValues.Address);
       originalValues = {
        Address: convertedAddress,
        ...Object.keys(props.originalValues).reduce((acc, key) => {
            if (key !== 'Address') {  // Don't include Address here as it's already processed
                acc[key] = props.originalValues[key];
            }
            return acc;
        }, {})
        };
    }else{
        originalValues = props.originalValues
    }

    /**
     * Handle Popup close
     */
    const handleClose = () => {
               
            props.closePopup();
        
        setErrorFlag(false)
    }

    const onOkClick = () =>{
        history.push('/track-request')
    }

    /**
     * Handle comments Input
     * @param {*} event 
     */
    const handelChange = (event) => {
        setValue(event.target.value)
    }

    function filterEmptyValues(obj) {
        Object.keys(obj).forEach(key => {
          if (obj[key] && obj[key][0] && obj[key][0]['value'] === '') {
            delete obj[key]; 
          }
        });
        return obj;
      }

    /***
     * Zip Value Mapping
     */
    const getZipValue = (zip) => {
        if (zip === undefined) {
            return '';
        }
        let zip4 = zip.Zip4;
        let zip5 = zip.Zip5;
        let editZip = zip.value;
        if (editZip) {
            return editZip;
        }
        else if (!zip4 && !zip5) {
            return zip;
        }
        else if (zip4 === undefined) {
            return zip5[0].value;
        } else if (zip5 === undefined) {
            return zip4[0].value;
        } else {
            return zip5[0].value + '-' + zip4[0].value;
        }
    }

    /**
     * Primary address Logic
     * @param {*} updateDetails 
     * @param {*} detail 
     * @returns return address
     */
    const addPrimaryAddress = (updateDetails, detail) => {
        let value = updateDetails.entity.AddAddress[0];

        if (value.Rank[0].value === '1' && detail.entity.Address && detail.entity.Address.length > 0) {
            let oldAddress = JSON.parse(JSON.stringify(detail.entity.Address));
            let rankOneOldAddress = oldAddress.filter((value) => {
                let flag = false;
                if (value.Rank && value.Rank.length > 0) {
                    value.Rank.forEach((rankValue) => {
                        flag = flag || (rankValue.value === '1')
                    })
                }
                return flag;
            });
            rankOneOldAddress = (rankOneOldAddress && rankOneOldAddress.length > 0) ? rankOneOldAddress.map((addressValue) => {
                return {
                    ...addressValue,
                    Rank: [{ value: '2' }]
                }
            }) : [];
            return updateDetails.entity.AddAddress.concat(rankOneOldAddress);
        }
        return updateDetails.entity.AddAddress;
    }

    /**
     * Primary Relation logic
     * @param {*} updateDetails 
     * @param {*} detail 
     * @returns return relation
     */
    const addPrimaryRelation = (updateDetails, detail) => {
        let value = updateDetails.relations[0];
        if (value.Rank && value.Rank[0].value === '1' && detail.relations.length > 0) {
            let oldRelation = JSON.parse(JSON.stringify(detail.relations))
            let rankOneRelation = oldRelation.filter((value) => {
                let flag = false;
                if (value.Rank && value.Rank.length > 0) {
                    value.Rank.forEach((rankValue) => {
                        flag = flag || (rankValue.value === '1')
                    })
                }
                return flag;
            })
            if (rankOneRelation && rankOneRelation.length > 0) {
                rankOneRelation = rankOneRelation.map((rankOneRelationValue) => {
                    let uri = '';
                    let label = '';
                    if (rankOneRelationValue.startObject.objectURI.split('/')[1] !== props.uri) {
                        uri = rankOneRelationValue.startObject.objectURI.split('/')[1];
                        label = rankOneRelationValue.startObject.label;
                    } else {
                        uri = rankOneRelationValue.endObject.objectURI.split('/')[1];
                        label = rankOneRelationValue.endObject.label;
                    }
                    return {
                        ...rankOneRelationValue,
                        Rank: [{ value: '2' }],
                        uri: uri,
                        label: label
                    }
                })

            }

            return updateDetails.relations.concat(rankOneRelation);

        }
        return updateDetails.relations;
    }

    /**
     * Submit DCR
     */
    const submitRequest = () => {
        if (value && value.length > 0) {
            setOpen(true)
            setDisableSubmit(true);            
            let updateDetails = props.updateDetails;
            let detail = props.detail;
            if(props.isHcoWithoutRelation){
                let entityData = filterEmptyValues(updateDetails.entity)
                let finalComment = value;
                
                updateDetails.entity = entityData 
                const renderHTML = (html) => ({ __html: html });
                api.postUpdate({ ...updateDetails, comments: finalComment },{...originalValues}).then(res => {
                    let response = res.data[0]            
                    setSubmit(true);
                    setPopUptext({comment: popMsg[0].dcrSuccess.description.replace(/{{source}}/g, (LillySource.Success_Message_Source[0][response.vendor])), success: true, ok: true }) 
                    setOpen(false)
                    setValue('');              
                    setDisableSubmit(false);
                })
                .catch((error)=>{
                    setSubmit(true);
                    setPopUptext({comment:<div dangerouslySetInnerHTML={renderHTML(popMsg[0].dcrFailure.description)}/>, success: false , ok: true}) 
                    setOpen(false)
                    setValue('');
                    setDisableSubmit(false);
                }) 
            }else{
                
                if (updateDetails.relations.length > 0 && detail) {
                    updateDetails = {
                        ...updateDetails,
                        relations: addPrimaryRelation(updateDetails, detail)
                    }
                }
    
                if (updateDetails.entity.AddAddress !== undefined && !props.typeHCO) {
                    if (updateDetails.entity.Address === undefined) {
                        updateDetails.entity = {
                            ...updateDetails.entity,
                            Address: []
                        }
                    }
                    let rankOneOldAddress = updateDetails.entity.AddAddress && updateDetails.entity.AddAddress.length > 0 && addPrimaryAddress(updateDetails, detail);
                    updateDetails = {
                        ...updateDetails,
                        entity: {
                            ...updateDetails.entity,
                            Address: rankOneOldAddress
                        }
                    }
    
                    delete updateDetails.entity.AddAddress;
                }
                updateDetails.entity.Address !== undefined && !props.typeHCO &&
                    updateDetails.entity.Address.forEach((value) => {
                        delete value.editKey;
                        if(!value.IsStatusChanged){
                            value.Zip = [{ value: getZipValue(value.Zip && value.Zip[0] ? value.Zip[0] : undefined) }]
                        }
                    })
                let finalComment = '';
                if (props.addNewHCO !== undefined && updateDetails.relations.length > 0) {
                    if (updateDetails.entity.FirstName !== undefined && updateDetails.entity.LastName[0] !== undefined) {
                        let HCPName = updateDetails.entity.FirstName[0].value + ' ' + updateDetails.entity.LastName[0].value;
                        finalComment = updateDetails.relations[0].uri !== undefined ? (`${value} || For HCP(${HCPName}), Added relation to HCO (${updateDetails.relations[0].label}) with Reltio Id (${updateDetails.relations[0].uri}) is submitted.`) : value;
                    } else {
                        finalComment = value;
                    }
                } else {
                    finalComment = value;
                }
                if(updateDetails.entity.NewSpecialities && props.location != undefined && props.location == 'edit' ){
                    let allSpecialities = updateDetails.entity.Specialities.filter((item)=> item.Rank && item.Rank[0].value == '1')
                    allSpecialities.forEach(item => item.Rank[0].value = '99' );
                    updateDetails = {
                        ...updateDetails,
                        entity: {
                            ...updateDetails.entity,
                            Specialities: allSpecialities
                        }
                    }                
    
                }            
                let entityData = filterEmptyValues(updateDetails.entity) 
                let relationData = filterEmptyValues(updateDetails.relations)
                updateDetails.entity = entityData 
                updateDetails.relations = relationData
                const renderHTML = (html) => ({ __html: html });
                api.postUpdate({ ...updateDetails, comments: finalComment },{...originalValues}).then(res => {
                    let response = res.data[0]            
                    setSubmit(true);
                    setPopUptext({comment: popMsg[0].dcrSuccess.description.replace(/{{source}}/g, (LillySource.Success_Message_Source[0][response.vendor])), success: true, ok: true }) 
                    setOpen(false)
                    setValue('');              
                    setDisableSubmit(false);
                })
                .catch((error)=>{
                    setSubmit(true);
                    setPopUptext({comment:<div dangerouslySetInnerHTML={renderHTML(popMsg[0].dcrFailure.description)}/>, success: false , ok: true}) 
                    setOpen(false)
                    setValue('');
                    setDisableSubmit(false);
                })
            }

          
        }
        else{
            setErrorFlag(true)
        }
    }

    return (<>

    

        <Dialog
            open={props.open}
            onClose={handleClose}
            aria-labelledby="contentIdbox"
            aria-describedby="contentIdboxdes"
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="DialogTxtbox" color='primary' className='fw-bold' >{props.title || ''}</DialogTitle>
            <DialogContent id="contentIdbox">
            {submit ? popUptext.success ? <center><CheckCircleRoundedIcon className='success' /></center> : <center><CancelIcon className='secondary' /></center> :
                    <DialogContentText id="contentIdboxdes">
                        {props.message}
                    </DialogContentText>
             }
                {
                    submit &&
                    <>
                        <h6 id="idboxContent">
                        {popUptext.comment}
                        </h6>
                    </>
                }
                {
                    props.success && !submit &&
                    <TextField
                        value={value}
                        className='w-100'
                        onChange={handelChange}
                        multiline
                        rows={3}
                        variant="outlined"
                        error={errorFlag && value.length === 0}
                        helperText={errorFlag && value.length === 0 ? `Please Enter Value` : ''}                        
                    />
                }
                { open &&
                    <center className='mt-2'><ProgressBar size={0.99 * 50} /> </center>
                }
            </DialogContent>

            <DialogActions sx={{mr: '15px'}} id="dialog-action">
            {  ((props.success && !submit) || (!props.success && props.open)) && 
            <Button onClick={()=>handleClose()} color="error" variant="outlined" autoFocus> Close </Button>}
            {
                    props.success && !submit &&
                    <Button 
                        onClick={()=> submitRequest()} 
                        color="error" 
                        variant="contained" 
                        autoFocus
                        disabled={disableSubmit}
                    
                    >
                        Submit                                </Button>
                }

                { (submit && popUptext.ok ) && <Button onClick={()=>onOkClick()} color="error" variant="contained" autoFocus>
                    Confirm
                                </Button>}
            </DialogActions>
        </Dialog>
        </>
    )
}

export default PopupConfimation;